module.exports = "mat-card {\n  width: 80%;\n  margin-top: 2vh;\n  margin-left: 10%; }\n\n.calendar-container {\n  margin-left: 5%;\n  width: 40%; }\n"